import { Crop } from 'react-image-crop';
import { EventPageType } from '@graphql/generated';
import { SinglePhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';
import { createTelemetryObject } from '@shared/core/analytics/telemetry/utils';
import { createTelemetry } from '@shared/core/analytics/telemetry/create.telemetry';

const action = 'PagePhotoEditorButtonInteracted';

const telemObject = createTelemetryObject({
  actions: {
    photoPresentationLayoutClicked: (args: {
      category: string;
      presentationLayout: SinglePhotoPresentationLayout;
      pageId: string | undefined;
      pageType: EventPageType | undefined;
    }) => ({
      action,
      category: args.category,
      extraInfo: {
        name: 'photoPresentationLayoutClicked',
        presentationLayout: args.presentationLayout,
        pageId: args.pageId,
        pageType: args.pageType,
      },
    }),
    pagePhotoCropped: (category: string, args: { pageId: string | undefined; pageType: EventPageType | undefined; photoPresentationLayout: SinglePhotoPresentationLayout }) => ({
      action: 'PagePhotoCropped',
      category,
      extraInfo: {
        ...args,
      },
    }),
    saveFullWidthPhotoChangesButtonClicked: (category: string, args: { pageId: string | undefined; pageType: EventPageType | undefined; cropData: Crop }) => ({
      action,
      category,
      extraInfo: {
        name: 'websitePagePhoto_fullWidthEditor_saveClicked',
        ...args,
      },
    }),
    editPagePhotoClicked: (category: string, pageType: string) => ({
      action,
      category,
      extraInfo: {
        name: 'editPagePhotoClicked',
        pageType,
      },
    }),

    photoEditorOpened: (category: string, label: 'opened' | 'closed') => ({
      action: 'PagePhotoEditorStatus',
      category,
      label,
    }),

    photoEditorChangePhotoClicked: (category: string) => ({
      action: 'PagePhotoEditorChangePhoto',
      actionType: 'click',
      category,
    }),

    pagePhotoUpdated: (category: string, action: 'FocusChanged' | 'Update' | 'Delete', status: 'succeeded' | 'failed', extraInfo: Object = {}) => ({
      action: 'PagePhotoUpdated',
      category,
      extraInfo: {
        name: 'pagePhotoUpdated',
        label: action,
        status,
        ...extraInfo,
      },
    }),
  },
});

const { TelemetryProvider: FocusPointEditorTelemetryProvider, useTelemetry: useFocusPointEditorTelemetry } = createTelemetry(telemObject);

export { FocusPointEditorTelemetryProvider, useFocusPointEditorTelemetry };
